import { TenantPerformableFormProps } from '~/tenants/common/form';
import { TwtOrderContext } from '~/tenants/twt/model/TwtOrder';
import { PersonaType } from '~/tenants/common/TenantPersona';
import TwtNucleusAddOns from '~/tenants/twt/performable/nucleus/TwtNucleusAddOns';
import React from 'react';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import TwtDetached from '~/tenants/twt/forms/TwtDetached';
import { TenantPackageAddOnTemplate } from '~/tenants/common/package';
import InputCheckbox from '~/components/input/InputCheckbox';
import PerformableGroupForm, {
  useIsPerformableGroup,
  usePerformableGroup,
} from '~/components/performable/PerformableGroupForm';
import TwtNucleusGuidedConfig from '~/tenants/twt/performable/nucleus-guided/TwtNucleusGuidedConfig';
import TwtNucleusGuidedForm from '~/tenants/twt/performable/nucleus-guided/TwtNucleusGuidedForm';
import TwtNucleusHotspotsConfig from '~/tenants/twt/performable/nucleus-hotspots/TwtNucleusHotspotsConfig';
import TwtNucleusHotspotsForm from '~/tenants/twt/performable/nucleus-hotspots/TwtNucleusHotspotsForm';
import TwtNucleusJob from '~/tenants/twt/performable/nucleus/TwtNucleusJob';

export default function TwtNucleusForm({ create, persona }: TenantPerformableFormProps<TwtOrderContext>) {
  const grouped = useIsPerformableGroup();

  return (
    <div className="space-y-4">
      {persona === PersonaType.CUSTOMER && create && (
        <iframe
          src="https://portal.nucleus4d.com/?session=21b83437-14a0-4d19-891b-08120e75d6c6"
          className="w-full h-[400px] rounded-theme overflow-hidden"
        />
      )}
      <TwtDetached />
      <TenantPerformableAddOns persona={persona}>
        <TwtNucleusAddOns persona={persona} />
        {grouped && <TwtNucleusJobAddOns persona={persona} />}
      </TenantPerformableAddOns>
    </div>
  );
}

function TwtNucleusJobAddOns({ persona }: { persona: PersonaType }) {
  const group = usePerformableGroup();

  return (
    <>
      <TenantPackageAddOnTemplate
        htmlFor="nucleusguided"
        title="Live Virtual Tours"
        description={TwtNucleusGuidedConfig.short}
        image="tenant/twt/nucleus/live_guided.png"
        cost={`$${TwtNucleusJob.guided(25)}+`}
        persona={persona}
        enable={
          <InputCheckbox
            id="nucleusguided"
            checked={group.hasPerformable(TwtNucleusGuidedConfig)}
            onChange={() => {
              if (group.hasPerformable(TwtNucleusGuidedConfig)) {
                group.removePerformable(TwtNucleusGuidedConfig);
              } else {
                group.addPerformable(TwtNucleusGuidedConfig, { guided: 25 });
              }
            }}
          />
        }
      />

      {group.hasPerformable(TwtNucleusGuidedConfig) && (
        <PerformableGroupForm performable={TwtNucleusGuidedConfig}>
          <TwtNucleusGuidedForm />
        </PerformableGroupForm>
      )}

      <TenantPackageAddOnTemplate
        htmlFor="nucleushotspots"
        title="Hotspots"
        description={TwtNucleusHotspotsConfig.short}
        image="tenant/twt/nucleus/hotspot.jpg"
        cost={`$${TwtNucleusJob.hotspots(20)}+`}
        persona={persona}
        enable={
          <InputCheckbox
            id="nucleushotspots"
            checked={group.hasPerformable(TwtNucleusHotspotsConfig)}
            onChange={() => {
              if (group.hasPerformable(TwtNucleusHotspotsConfig)) {
                group.removePerformable(TwtNucleusHotspotsConfig);
              } else {
                group.addPerformable(TwtNucleusHotspotsConfig, { hotspots: 20, instructions: '' });
              }
            }}
          />
        }
      />

      {group.hasPerformable(TwtNucleusHotspotsConfig) && (
        <PerformableGroupForm performable={TwtNucleusHotspotsConfig}>
          <TwtNucleusHotspotsForm />
        </PerformableGroupForm>
      )}
    </>
  );
}
